import * as React from 'react'
import * as ReactDOM from 'react-dom'

/**
 * Create a React portal and clear the contents of the given element
 * @param reactElement React element to render
 * @param element HTML element to render React element into
 * @returns React portal
 */
export default function createRootPortal(
  reactElement: React.ReactElement,
  element: HTMLElement | Element | null | undefined
): React.ReactElement {
  if (!element) throw new Error('element not found')
  element.innerHTML = ''
  return ReactDOM.createPortal(reactElement, element)
}
